module.exports = __webpack_public_path__ + "img/corseal.bbf4e3c4.png";